// extracted by mini-css-extract-plugin
export default {"container":"BC2co_container","add-btn-text":"TzHz8_add-btn-text","icon":"CiUNx_icon"};